import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { groupRegionConfigsByName } from '@/utilities/groupRegionConfigsByName';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';
import { orderBy } from 'lodash';

const key = FilterKey.RISK_REGION;
export const getRiskRegionFilter = ({
  activeFilters,
  regionConfigs,
  userRole,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const canFilterRiskRegion = hasPerm(userRole || UserRole.Unknown, P.FILTER_RISK_REGION);
  if (!canFilterRiskRegion) {
    return null;
  }
  const regionConfigFilterOptions = filterOptions?.riskRegion || [];
  const usedRegionConfigs = (regionConfigs || []).filter(config => regionConfigFilterOptions.includes(config.id));

  const allRegionConfigs: { label: string; value: string }[] = usedRegionConfigs?.length
    ? groupRegionConfigsByName(usedRegionConfigs)
    : [];

  const filters = activeFilters[key] ?? [];

  const options = allRegionConfigs.map(region => {
    return {
      label: region.label ?? 'Default low risk region',
      value: region.value,
      checked: filters.some(filter => filter === region.value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Risk region',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
